// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── SignatureFlow Modal ─────────────────────────────────────── */

.signature-modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.signature-modal-panel {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
  width: min(560px, 92vw);
  max-height: 90vh;
  display: flex;
  flex-direction: column;
}

.signature-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.5rem 2rem;
  border-bottom: 1px solid #e5e7eb;
}

.signature-modal-header h2 {
  font-size: 1.6rem;
  font-weight: 700;
  color: #374151;
  margin: 0;
}

.signature-modal-body {
  padding: 1.5rem 2rem 2rem;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.signature-modal-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 3rem 1rem;
}

.signature-modal-loading .spinner {
  width: 36px;
  height: 36px;
  border: 3px solid #e5e7eb;
  border-top-color: #f97316;
  border-radius: 50%;
  animation: sig-spin 1s linear infinite;
  margin-bottom: 1rem;
}

@keyframes sig-spin {
  to {
    transform: rotate(360deg);
  }
}

.signature-modal-loading p {
  color: #6b7280;
  font-size: 1.3rem;
  margin: 0;
}

.signature-modal-error {
  text-align: center;
  padding: 2rem 1rem;
}

.signature-modal-error p {
  color: #ef4444;
  font-size: 1.3rem;
  margin: 0 0 1.5rem;
}

.signature-modal-separator {
  height: 1px;
  background: #e5e7eb;
  margin: 0.25rem 0;
}

/* ── Identity edit section ──────────────────────────────────── */

.signature-identity-section {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.signature-identity-label {
  font-size: 1.25rem;
  color: #374151;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.signature-identity-edit-btn {
  background: none;
  border: none;
  color: #f97316;
  font-size: 1.15rem;
  cursor: pointer;
  text-decoration: underline;
  padding: 0;
}

.signature-identity-edit-btn:hover {
  color: #ea580c;
}

.signature-identity-fields {
  display: flex;
  gap: 0.75rem;
  align-items: flex-end;
  flex-wrap: wrap;
}

/* Champ texte direct du nom du signataire (assez grand) */
.signature-identity-input-large {
  flex: 1 1 auto;
  min-width: 220px;
  font-size: 1.8rem;
  padding: 1rem 1.2rem;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  color: #374151;
}

.signature-identity-input-large:focus {
  outline: none;
  border-color: #f97316;
}

/* Zone signature verrouillée tant que le nom n'est pas validé */
.signature-canvas-lock-hint {
  color: #6b7280;
  font-size: 1.4rem;
  text-align: center;
  margin: 0 0 0.8rem;
}

.signature-canvas-lockwrap.is-locked {
  opacity: 0.45;
  filter: grayscale(1);
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
}

.signature-identity-field {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  flex: 1 1;
  min-width: 140px;
}

.signature-identity-field label {
  font-size: 1.1rem;
  color: #6b7280;
  font-weight: 600;
}

.signature-identity-field input {
  padding: 0.4rem 0.6rem;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 1.2rem;
  color: #374151;
}

.signature-identity-field input:focus {
  outline: none;
  border-color: #f97316;
  box-shadow: 0 0 0 2px rgba(249, 115, 22, 0.15);
}

.signature-identity-done-btn {
  background: #f97316;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 0.4rem 1rem;
  font-size: 1.15rem;
  cursor: pointer;
  font-weight: 600;
}

.signature-identity-done-btn:hover {
  background: #ea580c;
}

.signature-modal-checkbox {
  display: flex;
  align-items: flex-start;
  gap: 0.6rem;
  cursor: pointer;
  font-size: 1.25rem;
  color: #374151;
}

.signature-modal-checkbox input[type="checkbox"] {
  margin-top: 2px;
  width: 16px;
  height: 16px;
  accent-color: #f97316;
}

.signature-modal-inline-error {
  color: #ef4444;
  font-size: 1.2rem;
  padding: 0.5rem 0.75rem;
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 6px;
}

.signature-modal-actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding-top: 0.5rem;
  gap: 0.75rem;
}

.signature-modal-actions button {
  min-width: 220px;
}

.signature-modal-hint {
  width: 100%;
  text-align: center;
  font-size: 1.15rem;
  color: #9ca3af;
  margin: 0;
  font-style: italic;
}

/* ── Success state ──────────────────────────────────────────── */

.signature-modal-success {
  text-align: center;
  padding: 2rem 1rem;
}

.signature-modal-success-icon {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: #22c55e;
  color: #fff;
  font-size: 2.4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1.25rem;
}

.signature-modal-success h3 {
  font-size: 1.6rem;
  font-weight: 700;
  color: #374151;
  margin: 0 0 0.75rem;
}

.signature-modal-success p {
  font-size: 1.25rem;
  color: #6b7280;
  margin: 0 0 1.5rem;
}

.signature-modal-success-actions {
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
}

/* ── OTP Section ────────────────────────────────────────────── */

.otp-section {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.otp-title {
  font-size: 1.3rem;
  font-weight: 700;
  color: #374151;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.otp-canal-choice {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.otp-canal-option {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1.25rem;
  color: #374151;
  cursor: pointer;
  padding: 0.4rem 0;
}

.otp-canal-option.active {
  font-weight: 600;
}

.otp-canal-option.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.otp-canal-option input[type="radio"] {
  accent-color: #f97316;
  width: 16px;
  height: 16px;
}

.otp-phone-update {
  margin-left: 1.5rem;
  margin-top: 6px;
  width: 100%;
}

.otp-phone-update-label {
  font-size: 1.1rem;
  color: #6b7280;
  margin: 0 0 6px 0;
}

.otp-phone-update-row {
  display: flex;
  gap: 8px;
  align-items: center;
}

.otp-phone-input {
  flex: 1 1;
  padding: 6px 10px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  font-size: 1.3rem;
  max-width: 180px;
}

.otp-phone-input:focus {
  outline: none;
  border-color: #f97316;
}

.otp-phone-error {
  display: block;
  font-size: 1.1rem;
  color: #dc2626;
  margin-top: 4px;
}

.otp-send-row {
  display: flex;
  padding-top: 0.25rem;
}

.otp-digits-row {
  display: flex;
  align-items: center;
  gap: 0.4rem;
}

.otp-digit-input {
  width: 38px;
  height: 44px;
  text-align: center;
  font-size: 1.5rem;
  font-weight: 600;
  font-family: "Courier New", monospace;
  border: 2px solid #d1d5db;
  border-radius: 8px;
  outline: none;
  transition: border-color 0.15s;
}

.otp-digit-input:focus {
  border-color: #f97316;
  box-shadow: 0 0 0 2px rgba(249, 115, 22, 0.15);
}

.otp-resend-row {
  font-size: 1.15rem;
  color: #6b7280;
}

.otp-resend-cooldown {
  color: #9ca3af;
}

.otp-resend-link {
  background: none;
  border: none;
  color: #f97316;
  font-size: 1.15rem;
  cursor: pointer;
  text-decoration: underline;
  padding: 0;
}

.otp-resend-link:hover {
  color: #ea580c;
}

.otp-error {
  color: #ef4444;
  font-size: 1.2rem;
  padding: 0.4rem 0.75rem;
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 6px;
}

.otp-success {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.6rem 1rem;
  background: #f0fdf4;
  border: 1px solid #bbf7d0;
  border-radius: 8px;
  font-size: 1.3rem;
  font-weight: 600;
  color: #16a34a;
}

.otp-success-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #22c55e;
  color: #fff;
  font-size: 1rem;
  font-weight: 700;
}

/* ── Signature Canvas ───────────────────────────────────────── */

.signature-canvas-container {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.signature-canvas-label {
  font-size: 1.3rem;
  font-weight: 700;
  color: #374151;
}

.signature-canvas-tabs {
  display: flex;
  gap: 0;
  border-bottom: 2px solid #e5e7eb;
}

.signature-canvas-tab {
  padding: 0.5rem 1.25rem;
  font-size: 1.2rem;
  font-weight: 500;
  color: #6b7280;
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  margin-bottom: -2px;
  cursor: pointer;
  transition: all 0.15s;
}

.signature-canvas-tab.active {
  color: #f97316;
  border-bottom-color: #f97316;
  font-weight: 600;
}

.signature-canvas-tab:hover:not(.active) {
  color: #374151;
}

.signature-canvas-area {
  position: relative;
  border: 2px dashed #d1d5db;
  border-radius: 8px;
  background: #fafafa;
  min-height: 120px;
}

.signature-canvas-pad {
  display: block;
  width: 100%;
  height: 120px;
  cursor: crosshair;
}

.signature-canvas-text-preview {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 120px;
  padding: 1rem;
}

.signature-canvas-text-cursive {
  font-family: "Georgia", "Times New Roman", serif;
  font-style: italic;
  font-size: 2.4rem;
  color: #1a1a2e;
  -webkit-user-select: none;
          user-select: none;
}

.signature-canvas-clear-btn {
  position: absolute;
  top: 6px;
  right: 8px;
  background: none;
  border: none;
  font-size: 1.4rem;
  cursor: pointer;
  opacity: 0.5;
  transition: opacity 0.15s;
  padding: 2px 4px;
}

.signature-canvas-clear-btn:hover {
  opacity: 1;
}

.signature-canvas-identity {
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.signature-canvas-name {
  font-size: 1.25rem;
  font-weight: 600;
  color: #374151;
}

.signature-canvas-function {
  font-size: 1.15rem;
  color: #6b7280;
  font-style: italic;
}

/* ── ContratPreview ─────────────────────────────────────────── */

.contrat-preview-container {
  display: flex;
}

/* ── Responsive ─────────────────────────────────────────────── */

@media (max-width: 640px) {
  .signature-modal-panel {
    width: 100vw;
    max-height: 100vh;
    border-radius: 0;
  }

  .otp-digit-input {
    width: 32px;
    height: 38px;
    font-size: 1.3rem;
  }

  .signature-canvas-text-cursive {
    font-size: 1.8rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Publications/components/SignatureContrat/SignatureFlow.css"],"names":[],"mappings":"AAAA,mEAAmE;;AAEnE;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,kEAAkE;;AAElE;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,0BAA0B;EAC1B,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,qBAAqB;EACrB,eAAe;AACjB;;AAEA,0DAA0D;AAC1D;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA,gEAAgE;AAChE;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,oBAAoB;EACpB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,SAAS;EACT,kBAAkB;AACpB;;AAEA,kEAAkE;;AAElE;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;AACjB;;AAEA,kEAAkE;;AAElE;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,qCAAqC;EACrC,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,0BAA0B;EAC1B,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA,kEAAkE;;AAElE;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,MAAM;EACN,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,oCAAoC;EACpC,mBAAmB;EACnB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,gDAAgD;EAChD,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA,kEAAkE;;AAElE;EACE,aAAa;AACf;;AAEA,kEAAkE;;AAElE;EACE;IACE,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["/* ── SignatureFlow Modal ─────────────────────────────────────── */\n\n.signature-modal-backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.45);\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.signature-modal-panel {\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);\n  width: min(560px, 92vw);\n  max-height: 90vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.signature-modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1.5rem 2rem;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.signature-modal-header h2 {\n  font-size: 1.6rem;\n  font-weight: 700;\n  color: #374151;\n  margin: 0;\n}\n\n.signature-modal-body {\n  padding: 1.5rem 2rem 2rem;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 1.25rem;\n}\n\n.signature-modal-loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 3rem 1rem;\n}\n\n.signature-modal-loading .spinner {\n  width: 36px;\n  height: 36px;\n  border: 3px solid #e5e7eb;\n  border-top-color: #f97316;\n  border-radius: 50%;\n  animation: sig-spin 1s linear infinite;\n  margin-bottom: 1rem;\n}\n\n@keyframes sig-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.signature-modal-loading p {\n  color: #6b7280;\n  font-size: 1.3rem;\n  margin: 0;\n}\n\n.signature-modal-error {\n  text-align: center;\n  padding: 2rem 1rem;\n}\n\n.signature-modal-error p {\n  color: #ef4444;\n  font-size: 1.3rem;\n  margin: 0 0 1.5rem;\n}\n\n.signature-modal-separator {\n  height: 1px;\n  background: #e5e7eb;\n  margin: 0.25rem 0;\n}\n\n/* ── Identity edit section ──────────────────────────────────── */\n\n.signature-identity-section {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.signature-identity-label {\n  font-size: 1.25rem;\n  color: #374151;\n  margin: 0;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n}\n\n.signature-identity-edit-btn {\n  background: none;\n  border: none;\n  color: #f97316;\n  font-size: 1.15rem;\n  cursor: pointer;\n  text-decoration: underline;\n  padding: 0;\n}\n\n.signature-identity-edit-btn:hover {\n  color: #ea580c;\n}\n\n.signature-identity-fields {\n  display: flex;\n  gap: 0.75rem;\n  align-items: flex-end;\n  flex-wrap: wrap;\n}\n\n/* Champ texte direct du nom du signataire (assez grand) */\n.signature-identity-input-large {\n  flex: 1 1 auto;\n  min-width: 220px;\n  font-size: 1.8rem;\n  padding: 1rem 1.2rem;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  color: #374151;\n}\n\n.signature-identity-input-large:focus {\n  outline: none;\n  border-color: #f97316;\n}\n\n/* Zone signature verrouillée tant que le nom n'est pas validé */\n.signature-canvas-lock-hint {\n  color: #6b7280;\n  font-size: 1.4rem;\n  text-align: center;\n  margin: 0 0 0.8rem;\n}\n\n.signature-canvas-lockwrap.is-locked {\n  opacity: 0.45;\n  filter: grayscale(1);\n  pointer-events: none;\n  user-select: none;\n}\n\n.signature-identity-field {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  flex: 1;\n  min-width: 140px;\n}\n\n.signature-identity-field label {\n  font-size: 1.1rem;\n  color: #6b7280;\n  font-weight: 600;\n}\n\n.signature-identity-field input {\n  padding: 0.4rem 0.6rem;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  font-size: 1.2rem;\n  color: #374151;\n}\n\n.signature-identity-field input:focus {\n  outline: none;\n  border-color: #f97316;\n  box-shadow: 0 0 0 2px rgba(249, 115, 22, 0.15);\n}\n\n.signature-identity-done-btn {\n  background: #f97316;\n  color: #fff;\n  border: none;\n  border-radius: 6px;\n  padding: 0.4rem 1rem;\n  font-size: 1.15rem;\n  cursor: pointer;\n  font-weight: 600;\n}\n\n.signature-identity-done-btn:hover {\n  background: #ea580c;\n}\n\n.signature-modal-checkbox {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.6rem;\n  cursor: pointer;\n  font-size: 1.25rem;\n  color: #374151;\n}\n\n.signature-modal-checkbox input[type=\"checkbox\"] {\n  margin-top: 2px;\n  width: 16px;\n  height: 16px;\n  accent-color: #f97316;\n}\n\n.signature-modal-inline-error {\n  color: #ef4444;\n  font-size: 1.2rem;\n  padding: 0.5rem 0.75rem;\n  background: #fef2f2;\n  border: 1px solid #fecaca;\n  border-radius: 6px;\n}\n\n.signature-modal-actions {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  padding-top: 0.5rem;\n  gap: 0.75rem;\n}\n\n.signature-modal-actions button {\n  min-width: 220px;\n}\n\n.signature-modal-hint {\n  width: 100%;\n  text-align: center;\n  font-size: 1.15rem;\n  color: #9ca3af;\n  margin: 0;\n  font-style: italic;\n}\n\n/* ── Success state ──────────────────────────────────────────── */\n\n.signature-modal-success {\n  text-align: center;\n  padding: 2rem 1rem;\n}\n\n.signature-modal-success-icon {\n  width: 60px;\n  height: 60px;\n  border-radius: 50%;\n  background: #22c55e;\n  color: #fff;\n  font-size: 2.4rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 1.25rem;\n}\n\n.signature-modal-success h3 {\n  font-size: 1.6rem;\n  font-weight: 700;\n  color: #374151;\n  margin: 0 0 0.75rem;\n}\n\n.signature-modal-success p {\n  font-size: 1.25rem;\n  color: #6b7280;\n  margin: 0 0 1.5rem;\n}\n\n.signature-modal-success-actions {\n  display: flex;\n  gap: 1rem;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n/* ── OTP Section ────────────────────────────────────────────── */\n\n.otp-section {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.otp-title {\n  font-size: 1.3rem;\n  font-weight: 700;\n  color: #374151;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n}\n\n.otp-canal-choice {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.otp-canal-option {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 1.25rem;\n  color: #374151;\n  cursor: pointer;\n  padding: 0.4rem 0;\n}\n\n.otp-canal-option.active {\n  font-weight: 600;\n}\n\n.otp-canal-option.disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.otp-canal-option input[type=\"radio\"] {\n  accent-color: #f97316;\n  width: 16px;\n  height: 16px;\n}\n\n.otp-phone-update {\n  margin-left: 1.5rem;\n  margin-top: 6px;\n  width: 100%;\n}\n\n.otp-phone-update-label {\n  font-size: 1.1rem;\n  color: #6b7280;\n  margin: 0 0 6px 0;\n}\n\n.otp-phone-update-row {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.otp-phone-input {\n  flex: 1;\n  padding: 6px 10px;\n  border: 1px solid #d1d5db;\n  border-radius: 4px;\n  font-size: 1.3rem;\n  max-width: 180px;\n}\n\n.otp-phone-input:focus {\n  outline: none;\n  border-color: #f97316;\n}\n\n.otp-phone-error {\n  display: block;\n  font-size: 1.1rem;\n  color: #dc2626;\n  margin-top: 4px;\n}\n\n.otp-send-row {\n  display: flex;\n  padding-top: 0.25rem;\n}\n\n.otp-digits-row {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n}\n\n.otp-digit-input {\n  width: 38px;\n  height: 44px;\n  text-align: center;\n  font-size: 1.5rem;\n  font-weight: 600;\n  font-family: \"Courier New\", monospace;\n  border: 2px solid #d1d5db;\n  border-radius: 8px;\n  outline: none;\n  transition: border-color 0.15s;\n}\n\n.otp-digit-input:focus {\n  border-color: #f97316;\n  box-shadow: 0 0 0 2px rgba(249, 115, 22, 0.15);\n}\n\n.otp-resend-row {\n  font-size: 1.15rem;\n  color: #6b7280;\n}\n\n.otp-resend-cooldown {\n  color: #9ca3af;\n}\n\n.otp-resend-link {\n  background: none;\n  border: none;\n  color: #f97316;\n  font-size: 1.15rem;\n  cursor: pointer;\n  text-decoration: underline;\n  padding: 0;\n}\n\n.otp-resend-link:hover {\n  color: #ea580c;\n}\n\n.otp-error {\n  color: #ef4444;\n  font-size: 1.2rem;\n  padding: 0.4rem 0.75rem;\n  background: #fef2f2;\n  border: 1px solid #fecaca;\n  border-radius: 6px;\n}\n\n.otp-success {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.6rem 1rem;\n  background: #f0fdf4;\n  border: 1px solid #bbf7d0;\n  border-radius: 8px;\n  font-size: 1.3rem;\n  font-weight: 600;\n  color: #16a34a;\n}\n\n.otp-success-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  background: #22c55e;\n  color: #fff;\n  font-size: 1rem;\n  font-weight: 700;\n}\n\n/* ── Signature Canvas ───────────────────────────────────────── */\n\n.signature-canvas-container {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.signature-canvas-label {\n  font-size: 1.3rem;\n  font-weight: 700;\n  color: #374151;\n}\n\n.signature-canvas-tabs {\n  display: flex;\n  gap: 0;\n  border-bottom: 2px solid #e5e7eb;\n}\n\n.signature-canvas-tab {\n  padding: 0.5rem 1.25rem;\n  font-size: 1.2rem;\n  font-weight: 500;\n  color: #6b7280;\n  background: none;\n  border: none;\n  border-bottom: 2px solid transparent;\n  margin-bottom: -2px;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.signature-canvas-tab.active {\n  color: #f97316;\n  border-bottom-color: #f97316;\n  font-weight: 600;\n}\n\n.signature-canvas-tab:hover:not(.active) {\n  color: #374151;\n}\n\n.signature-canvas-area {\n  position: relative;\n  border: 2px dashed #d1d5db;\n  border-radius: 8px;\n  background: #fafafa;\n  min-height: 120px;\n}\n\n.signature-canvas-pad {\n  display: block;\n  width: 100%;\n  height: 120px;\n  cursor: crosshair;\n}\n\n.signature-canvas-text-preview {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 120px;\n  padding: 1rem;\n}\n\n.signature-canvas-text-cursive {\n  font-family: \"Georgia\", \"Times New Roman\", serif;\n  font-style: italic;\n  font-size: 2.4rem;\n  color: #1a1a2e;\n  user-select: none;\n}\n\n.signature-canvas-clear-btn {\n  position: absolute;\n  top: 6px;\n  right: 8px;\n  background: none;\n  border: none;\n  font-size: 1.4rem;\n  cursor: pointer;\n  opacity: 0.5;\n  transition: opacity 0.15s;\n  padding: 2px 4px;\n}\n\n.signature-canvas-clear-btn:hover {\n  opacity: 1;\n}\n\n.signature-canvas-identity {\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n}\n\n.signature-canvas-name {\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: #374151;\n}\n\n.signature-canvas-function {\n  font-size: 1.15rem;\n  color: #6b7280;\n  font-style: italic;\n}\n\n/* ── ContratPreview ─────────────────────────────────────────── */\n\n.contrat-preview-container {\n  display: flex;\n}\n\n/* ── Responsive ─────────────────────────────────────────────── */\n\n@media (max-width: 640px) {\n  .signature-modal-panel {\n    width: 100vw;\n    max-height: 100vh;\n    border-radius: 0;\n  }\n\n  .otp-digit-input {\n    width: 32px;\n    height: 38px;\n    font-size: 1.3rem;\n  }\n\n  .signature-canvas-text-cursive {\n    font-size: 1.8rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
